import React, { Component } from 'react'
import { connect } from 'react-redux'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import ResetPasswordForm from '../components/ResetPasswordForm/ResetPasswordForm.js'
import ASCIIBackground from '../components/ASCIIBackground/ASCIIBackground.js'

class RecoverRoute extends Component {
  componentDidMount(){
    window.document.title = "zerowidth.ai - Reset Password";
  }

  render(){
    return <div className="hf-stretched">
      <div className="fixed-big-image">
        <ASCIIBackground 
          imagePath={'/home-img/forgot-password.png'} 
          foreground={'#C0C7D3'} 
          background={'#fff'} 
          autoTween={1000} 
          fontSize={16}
          placementMode={'contain-bottom'}
          />
      </div>
        <Header borderless={true}/>
      <div className="body">
        <div className="container">
          <div className="row justify-content-center padding-1rem">
            <div className="col-md-4">
              <div className="spacer-3rem"/><div className="spacer-3rem"/>
              <h1>Reset Password</h1>
              <ResetPasswordForm recover_code={this.props.recover_code}/>
            </div>
          </div>
        </div>
      </div>
      <Footer simple={true}/>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { userReducer } = state;

  return {
    userReducer
  }
}

export default connect(mapStateToProps)(RecoverRoute);
